__webpack_require__.p = "https://certificate.quantstamp.com/full/portal/472c70f3-e86b-42c4-8c49-ed244bb5265c/";